!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports["react-session"] = e() : t["react-session"] = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 10);
  }([function (t, e, n) {
    "use strict";

    t.exports = n(11);
  }, function (t, e, n) {
    t.exports = n(15)();
  }, function (t, e) {
    t.exports = function (t, e) {
      t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
    };
  }, function (t, e, n) {
    var r = n(18);
    t.exports = h, t.exports.parse = i, t.exports.compile = function (t, e) {
      return s(i(t, e), e);
    }, t.exports.tokensToFunction = s, t.exports.tokensToRegExp = p;
    var o = new RegExp(["(\\\\.)", "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"].join("|"), "g");
    function i(t, e) {
      for (var n, r = [], i = 0, a = 0, s = "", f = e && e.delimiter || "/"; null != (n = o.exec(t));) {
        var l = n[0],
          p = n[1],
          h = n.index;
        if (s += t.slice(a, h), a = h + l.length, p) s += p[1];else {
          var y = t[a],
            d = n[2],
            v = n[3],
            m = n[4],
            g = n[5],
            b = n[6],
            _ = n[7];
          s && (r.push(s), s = "");
          var x = null != d && null != y && y !== d,
            w = "+" === b || "*" === b,
            O = "?" === b || "*" === b,
            S = n[2] || f,
            P = m || g;
          r.push({
            name: v || i++,
            prefix: d || "",
            delimiter: S,
            optional: O,
            repeat: w,
            partial: x,
            asterisk: !!_,
            pattern: P ? c(P) : _ ? ".*" : "[^" + u(S) + "]+?"
          });
        }
      }
      return a < t.length && (s += t.substr(a)), s && r.push(s), r;
    }
    function a(t) {
      return encodeURI(t).replace(/[\/?#]/g, function (t) {
        return "%" + t.charCodeAt(0).toString(16).toUpperCase();
      });
    }
    function s(t, e) {
      for (var n = new Array(t.length), o = 0; o < t.length; o++) "object" == typeof t[o] && (n[o] = new RegExp("^(?:" + t[o].pattern + ")$", l(e)));
      return function (e, o) {
        for (var i = "", s = e || {}, u = (o || {}).pretty ? a : encodeURIComponent, c = 0; c < t.length; c++) {
          var f = t[c];
          if ("string" != typeof f) {
            var l,
              p = s[f.name];
            if (null == p) {
              if (f.optional) {
                f.partial && (i += f.prefix);
                continue;
              }
              throw new TypeError('Expected "' + f.name + '" to be defined');
            }
            if (r(p)) {
              if (!f.repeat) throw new TypeError('Expected "' + f.name + '" to not repeat, but received `' + JSON.stringify(p) + "`");
              if (0 === p.length) {
                if (f.optional) continue;
                throw new TypeError('Expected "' + f.name + '" to not be empty');
              }
              for (var h = 0; h < p.length; h++) {
                if (l = u(p[h]), !n[c].test(l)) throw new TypeError('Expected all "' + f.name + '" to match "' + f.pattern + '", but received `' + JSON.stringify(l) + "`");
                i += (0 === h ? f.prefix : f.delimiter) + l;
              }
            } else {
              if (l = f.asterisk ? encodeURI(p).replace(/[?#]/g, function (t) {
                return "%" + t.charCodeAt(0).toString(16).toUpperCase();
              }) : u(p), !n[c].test(l)) throw new TypeError('Expected "' + f.name + '" to match "' + f.pattern + '", but received "' + l + '"');
              i += f.prefix + l;
            }
          } else i += f;
        }
        return i;
      };
    }
    function u(t) {
      return t.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
    }
    function c(t) {
      return t.replace(/([=!:$\/()])/g, "\\$1");
    }
    function f(t, e) {
      return t.keys = e, t;
    }
    function l(t) {
      return t && t.sensitive ? "" : "i";
    }
    function p(t, e, n) {
      r(e) || (n = e || n, e = []);
      for (var o = (n = n || {}).strict, i = !1 !== n.end, a = "", s = 0; s < t.length; s++) {
        var c = t[s];
        if ("string" == typeof c) a += u(c);else {
          var p = u(c.prefix),
            h = "(?:" + c.pattern + ")";
          e.push(c), c.repeat && (h += "(?:" + p + h + ")*"), a += h = c.optional ? c.partial ? p + "(" + h + ")?" : "(?:" + p + "(" + h + "))?" : p + "(" + h + ")";
        }
      }
      var y = u(n.delimiter || "/"),
        d = a.slice(-y.length) === y;
      return o || (a = (d ? a.slice(0, -y.length) : a) + "(?:" + y + "(?=$))?"), a += i ? "$" : o && d ? "" : "(?=" + y + "|$)", f(new RegExp("^" + a, l(n)), e);
    }
    function h(t, e, n) {
      return r(e) || (n = e || n, e = []), n = n || {}, t instanceof RegExp ? function (t, e) {
        var n = t.source.match(/\((?!\?)/g);
        if (n) for (var r = 0; r < n.length; r++) e.push({
          name: r,
          prefix: null,
          delimiter: null,
          optional: !1,
          repeat: !1,
          partial: !1,
          asterisk: !1,
          pattern: null
        });
        return f(t, e);
      }(t, e) : r(t) ? function (t, e, n) {
        for (var r = [], o = 0; o < t.length; o++) r.push(h(t[o], e, n).source);
        return f(new RegExp("(?:" + r.join("|") + ")", l(n)), e);
      }(t, e, n) : function (t, e, n) {
        return p(i(t, n), e, n);
      }(t, e, n);
    }
  },, function (t, e, n) {
    "use strict";

    t.exports = n(19);
  }, function (t, e, n) {
    "use strict";

    var r,
      o = "object" == typeof Reflect ? Reflect : null,
      i = o && "function" == typeof o.apply ? o.apply : function (t, e, n) {
        return Function.prototype.apply.call(t, e, n);
      };
    r = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };
    var a = Number.isNaN || function (t) {
      return t != t;
    };
    function s() {
      s.init.call(this);
    }
    t.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var u = 10;
    function c(t) {
      if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    }
    function f(t) {
      return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners;
    }
    function l(t, e, n, r) {
      var o, i, a, s;
      if (c(n), void 0 === (i = t._events) ? (i = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== i.newListener && (t.emit("newListener", e, n.listener ? n.listener : n), i = t._events), a = i[e]), void 0 === a) a = i[e] = n, ++t._eventsCount;else if ("function" == typeof a ? a = i[e] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), (o = f(t)) > 0 && a.length > o && !a.warned) {
        a.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = a.length, s = u, console && console.warn && console.warn(s);
      }
      return t;
    }
    function p() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function h(t, e, n) {
      var r = {
          fired: !1,
          wrapFn: void 0,
          target: t,
          type: e,
          listener: n
        },
        o = p.bind(r);
      return o.listener = n, r.wrapFn = o, o;
    }
    function y(t, e, n) {
      var r = t._events;
      if (void 0 === r) return [];
      var o = r[e];
      return void 0 === o ? [] : "function" == typeof o ? n ? [o.listener || o] : [o] : n ? function (t) {
        for (var e = new Array(t.length), n = 0; n < e.length; ++n) e[n] = t[n].listener || t[n];
        return e;
      }(o) : v(o, o.length);
    }
    function d(t) {
      var e = this._events;
      if (void 0 !== e) {
        var n = e[t];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length;
      }
      return 0;
    }
    function v(t, e) {
      for (var n = new Array(e), r = 0; r < e; ++r) n[r] = t[r];
      return n;
    }
    Object.defineProperty(s, "defaultMaxListeners", {
      enumerable: !0,
      get: function () {
        return u;
      },
      set: function (t) {
        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        u = t;
      }
    }), s.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, s.prototype.getMaxListeners = function () {
      return f(this);
    }, s.prototype.emit = function (t) {
      for (var e = [], n = 1; n < arguments.length; n++) e.push(arguments[n]);
      var r = "error" === t,
        o = this._events;
      if (void 0 !== o) r = r && void 0 === o.error;else if (!r) return !1;
      if (r) {
        var a;
        if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
        var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw s.context = a, s;
      }
      var u = o[t];
      if (void 0 === u) return !1;
      if ("function" == typeof u) i(u, this, e);else {
        var c = u.length,
          f = v(u, c);
        for (n = 0; n < c; ++n) i(f[n], this, e);
      }
      return !0;
    }, s.prototype.addListener = function (t, e) {
      return l(this, t, e, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (t, e) {
      return l(this, t, e, !0);
    }, s.prototype.once = function (t, e) {
      return c(e), this.on(t, h(this, t, e)), this;
    }, s.prototype.prependOnceListener = function (t, e) {
      return c(e), this.prependListener(t, h(this, t, e)), this;
    }, s.prototype.removeListener = function (t, e) {
      var n, r, o, i, a;
      if (c(e), void 0 === (r = this._events)) return this;
      if (void 0 === (n = r[t])) return this;
      if (n === e || n.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[t], r.removeListener && this.emit("removeListener", t, n.listener || e));else if ("function" != typeof n) {
        for (o = -1, i = n.length - 1; i >= 0; i--) if (n[i] === e || n[i].listener === e) {
          a = n[i].listener, o = i;
          break;
        }
        if (o < 0) return this;
        0 === o ? n.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) t[e] = t[e + 1];
          t.pop();
        }(n, o), 1 === n.length && (r[t] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", t, a || e);
      }
      return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (t) {
      var e, n, r;
      if (void 0 === (n = this._events)) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[t]), this;
      if (0 === arguments.length) {
        var o,
          i = Object.keys(n);
        for (r = 0; r < i.length; ++r) "removeListener" !== (o = i[r]) && this.removeAllListeners(o);
        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }
      if ("function" == typeof (e = n[t])) this.removeListener(t, e);else if (void 0 !== e) for (r = e.length - 1; r >= 0; r--) this.removeListener(t, e[r]);
      return this;
    }, s.prototype.listeners = function (t) {
      return y(this, t, !0);
    }, s.prototype.rawListeners = function (t) {
      return y(this, t, !1);
    }, s.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : d.call(t, e);
    }, s.prototype.listenerCount = d, s.prototype.eventNames = function () {
      return this._eventsCount > 0 ? r(this._events) : [];
    };
  }, function (t, e, n) {
    t.exports.Dispatcher = n(13);
  }, function (t, e, n) {
    "use strict";

    (function (e) {
      var n = "__global_unique_id__";
      t.exports = function () {
        return e[n] = (e[n] || 0) + 1;
      };
    }).call(this, n(17));
  }, function (t, e, n) {
    "use strict";

    var r = n(5),
      o = {
        childContextTypes: !0,
        contextType: !0,
        contextTypes: !0,
        defaultProps: !0,
        displayName: !0,
        getDefaultProps: !0,
        getDerivedStateFromError: !0,
        getDerivedStateFromProps: !0,
        mixins: !0,
        propTypes: !0,
        type: !0
      },
      i = {
        name: !0,
        length: !0,
        prototype: !0,
        caller: !0,
        callee: !0,
        arguments: !0,
        arity: !0
      },
      a = {
        $$typeof: !0,
        compare: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0,
        type: !0
      },
      s = {};
    function u(t) {
      return r.isMemo(t) ? a : s[t.$$typeof] || o;
    }
    s[r.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    }, s[r.Memo] = a;
    var c = Object.defineProperty,
      f = Object.getOwnPropertyNames,
      l = Object.getOwnPropertySymbols,
      p = Object.getOwnPropertyDescriptor,
      h = Object.getPrototypeOf,
      y = Object.prototype;
    t.exports = function t(e, n, r) {
      if ("string" != typeof n) {
        if (y) {
          var o = h(n);
          o && o !== y && t(e, o, r);
        }
        var a = f(n);
        l && (a = a.concat(l(n)));
        for (var s = u(e), d = u(n), v = 0; v < a.length; ++v) {
          var m = a[v];
          if (!(i[m] || r && r[m] || d && d[m] || s && s[m])) {
            var g = p(n, m);
            try {
              c(e, m, g);
            } catch (t) {}
          }
        }
      }
      return e;
    };
  }, function (t, e, n) {
    t.exports = n(20);
  }, function (t, e, n) {
    "use strict";

    /** @license React v16.13.1
     * react.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var r = n(12),
      o = "function" == typeof Symbol && Symbol.for,
      i = o ? Symbol.for("react.element") : 60103,
      a = o ? Symbol.for("react.portal") : 60106,
      s = o ? Symbol.for("react.fragment") : 60107,
      u = o ? Symbol.for("react.strict_mode") : 60108,
      c = o ? Symbol.for("react.profiler") : 60114,
      f = o ? Symbol.for("react.provider") : 60109,
      l = o ? Symbol.for("react.context") : 60110,
      p = o ? Symbol.for("react.forward_ref") : 60112,
      h = o ? Symbol.for("react.suspense") : 60113,
      y = o ? Symbol.for("react.memo") : 60115,
      d = o ? Symbol.for("react.lazy") : 60116,
      v = "function" == typeof Symbol && Symbol.iterator;
    function m(t) {
      for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, n = 1; n < arguments.length; n++) e += "&args[]=" + encodeURIComponent(arguments[n]);
      return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var g = {
        isMounted: function () {
          return !1;
        },
        enqueueForceUpdate: function () {},
        enqueueReplaceState: function () {},
        enqueueSetState: function () {}
      },
      b = {};
    function _(t, e, n) {
      this.props = t, this.context = e, this.refs = b, this.updater = n || g;
    }
    function x() {}
    function w(t, e, n) {
      this.props = t, this.context = e, this.refs = b, this.updater = n || g;
    }
    _.prototype.isReactComponent = {}, _.prototype.setState = function (t, e) {
      if ("object" != typeof t && "function" != typeof t && null != t) throw Error(m(85));
      this.updater.enqueueSetState(this, t, e, "setState");
    }, _.prototype.forceUpdate = function (t) {
      this.updater.enqueueForceUpdate(this, t, "forceUpdate");
    }, x.prototype = _.prototype;
    var O = w.prototype = new x();
    O.constructor = w, r(O, _.prototype), O.isPureReactComponent = !0;
    var S = {
        current: null
      },
      P = Object.prototype.hasOwnProperty,
      j = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };
    function E(t, e, n) {
      var r,
        o = {},
        a = null,
        s = null;
      if (null != e) for (r in void 0 !== e.ref && (s = e.ref), void 0 !== e.key && (a = "" + e.key), e) P.call(e, r) && !j.hasOwnProperty(r) && (o[r] = e[r]);
      var u = arguments.length - 2;
      if (1 === u) o.children = n;else if (1 < u) {
        for (var c = Array(u), f = 0; f < u; f++) c[f] = arguments[f + 2];
        o.children = c;
      }
      if (t && t.defaultProps) for (r in u = t.defaultProps) void 0 === o[r] && (o[r] = u[r]);
      return {
        $$typeof: i,
        type: t,
        key: a,
        ref: s,
        props: o,
        _owner: S.current
      };
    }
    function C(t) {
      return "object" == typeof t && null !== t && t.$$typeof === i;
    }
    var k = /\/+/g,
      L = [];
    function R(t, e, n, r) {
      if (L.length) {
        var o = L.pop();
        return o.result = t, o.keyPrefix = e, o.func = n, o.context = r, o.count = 0, o;
      }
      return {
        result: t,
        keyPrefix: e,
        func: n,
        context: r,
        count: 0
      };
    }
    function $(t) {
      t.result = null, t.keyPrefix = null, t.func = null, t.context = null, t.count = 0, 10 > L.length && L.push(t);
    }
    function T(t, e, n) {
      return null == t ? 0 : function t(e, n, r, o) {
        var s = typeof e;
        "undefined" !== s && "boolean" !== s || (e = null);
        var u = !1;
        if (null === e) u = !0;else switch (s) {
          case "string":
          case "number":
            u = !0;
            break;
          case "object":
            switch (e.$$typeof) {
              case i:
              case a:
                u = !0;
            }
        }
        if (u) return r(o, e, "" === n ? "." + A(e, 0) : n), 1;
        if (u = 0, n = "" === n ? "." : n + ":", Array.isArray(e)) for (var c = 0; c < e.length; c++) {
          var f = n + A(s = e[c], c);
          u += t(s, f, r, o);
        } else if (null === e || "object" != typeof e ? f = null : f = "function" == typeof (f = v && e[v] || e["@@iterator"]) ? f : null, "function" == typeof f) for (e = f.call(e), c = 0; !(s = e.next()).done;) u += t(s = s.value, f = n + A(s, c++), r, o);else if ("object" === s) throw r = "" + e, Error(m(31, "[object Object]" === r ? "object with keys {" + Object.keys(e).join(", ") + "}" : r, ""));
        return u;
      }(t, "", e, n);
    }
    function A(t, e) {
      return "object" == typeof t && null !== t && null != t.key ? function (t) {
        var e = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + t).replace(/[=:]/g, function (t) {
          return e[t];
        });
      }(t.key) : e.toString(36);
    }
    function M(t, e) {
      t.func.call(t.context, e, t.count++);
    }
    function U(t, e, n) {
      var r = t.result,
        o = t.keyPrefix;
      t = t.func.call(t.context, e, t.count++), Array.isArray(t) ? D(t, r, n, function (t) {
        return t;
      }) : null != t && (C(t) && (t = function (t, e) {
        return {
          $$typeof: i,
          type: t.type,
          key: e,
          ref: t.ref,
          props: t.props,
          _owner: t._owner
        };
      }(t, o + (!t.key || e && e.key === t.key ? "" : ("" + t.key).replace(k, "$&/") + "/") + n)), r.push(t));
    }
    function D(t, e, n, r, o) {
      var i = "";
      null != n && (i = ("" + n).replace(k, "$&/") + "/"), T(t, U, e = R(e, i, r, o)), $(e);
    }
    var I = {
      current: null
    };
    function N() {
      var t = I.current;
      if (null === t) throw Error(m(321));
      return t;
    }
    var F = {
      ReactCurrentDispatcher: I,
      ReactCurrentBatchConfig: {
        suspense: null
      },
      ReactCurrentOwner: S,
      IsSomeRendererActing: {
        current: !1
      },
      assign: r
    };
    e.Children = {
      map: function (t, e, n) {
        if (null == t) return t;
        var r = [];
        return D(t, r, null, e, n), r;
      },
      forEach: function (t, e, n) {
        if (null == t) return t;
        T(t, M, e = R(null, null, e, n)), $(e);
      },
      count: function (t) {
        return T(t, function () {
          return null;
        }, null);
      },
      toArray: function (t) {
        var e = [];
        return D(t, e, null, function (t) {
          return t;
        }), e;
      },
      only: function (t) {
        if (!C(t)) throw Error(m(143));
        return t;
      }
    }, e.Component = _, e.Fragment = s, e.Profiler = c, e.PureComponent = w, e.StrictMode = u, e.Suspense = h, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = F, e.cloneElement = function (t, e, n) {
      if (null == t) throw Error(m(267, t));
      var o = r({}, t.props),
        a = t.key,
        s = t.ref,
        u = t._owner;
      if (null != e) {
        if (void 0 !== e.ref && (s = e.ref, u = S.current), void 0 !== e.key && (a = "" + e.key), t.type && t.type.defaultProps) var c = t.type.defaultProps;
        for (f in e) P.call(e, f) && !j.hasOwnProperty(f) && (o[f] = void 0 === e[f] && void 0 !== c ? c[f] : e[f]);
      }
      var f = arguments.length - 2;
      if (1 === f) o.children = n;else if (1 < f) {
        c = Array(f);
        for (var l = 0; l < f; l++) c[l] = arguments[l + 2];
        o.children = c;
      }
      return {
        $$typeof: i,
        type: t.type,
        key: a,
        ref: s,
        props: o,
        _owner: u
      };
    }, e.createContext = function (t, e) {
      return void 0 === e && (e = null), (t = {
        $$typeof: l,
        _calculateChangedBits: e,
        _currentValue: t,
        _currentValue2: t,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: f,
        _context: t
      }, t.Consumer = t;
    }, e.createElement = E, e.createFactory = function (t) {
      var e = E.bind(null, t);
      return e.type = t, e;
    }, e.createRef = function () {
      return {
        current: null
      };
    }, e.forwardRef = function (t) {
      return {
        $$typeof: p,
        render: t
      };
    }, e.isValidElement = C, e.lazy = function (t) {
      return {
        $$typeof: d,
        _ctor: t,
        _status: -1,
        _result: null
      };
    }, e.memo = function (t, e) {
      return {
        $$typeof: y,
        type: t,
        compare: void 0 === e ? null : e
      };
    }, e.useCallback = function (t, e) {
      return N().useCallback(t, e);
    }, e.useContext = function (t, e) {
      return N().useContext(t, e);
    }, e.useDebugValue = function () {}, e.useEffect = function (t, e) {
      return N().useEffect(t, e);
    }, e.useImperativeHandle = function (t, e, n) {
      return N().useImperativeHandle(t, e, n);
    }, e.useLayoutEffect = function (t, e) {
      return N().useLayoutEffect(t, e);
    }, e.useMemo = function (t, e) {
      return N().useMemo(t, e);
    }, e.useReducer = function (t, e, n) {
      return N().useReducer(t, e, n);
    }, e.useRef = function (t) {
      return N().useRef(t);
    }, e.useState = function (t) {
      return N().useState(t);
    }, e.version = "16.13.1";
  }, function (t, e, n) {
    "use strict";

    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;
    function a(t) {
      if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(t);
    }
    t.exports = function () {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;
        for (var e = {}, n = 0; n < 10; n++) e["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          r[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (t) {
        return !1;
      }
    }() ? Object.assign : function (t, e) {
      for (var n, s, u = a(t), c = 1; c < arguments.length; c++) {
        for (var f in n = Object(arguments[c])) o.call(n, f) && (u[f] = n[f]);
        if (r) {
          s = r(n);
          for (var l = 0; l < s.length; l++) i.call(n, s[l]) && (u[s[l]] = n[s[l]]);
        }
      }
      return u;
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = n(14),
      o = function () {
        function t() {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this._callbacks = {}, this._isDispatching = !1, this._isHandled = {}, this._isPending = {}, this._lastID = 1;
        }
        return t.prototype.register = function (t) {
          var e = "ID_" + this._lastID++;
          return this._callbacks[e] = t, e;
        }, t.prototype.unregister = function (t) {
          this._callbacks[t] || r(!1), delete this._callbacks[t];
        }, t.prototype.waitFor = function (t) {
          this._isDispatching || r(!1);
          for (var e = 0; e < t.length; e++) {
            var n = t[e];
            this._isPending[n] ? this._isHandled[n] || r(!1) : (this._callbacks[n] || r(!1), this._invokeCallback(n));
          }
        }, t.prototype.dispatch = function (t) {
          this._isDispatching && r(!1), this._startDispatching(t);
          try {
            for (var e in this._callbacks) this._isPending[e] || this._invokeCallback(e);
          } finally {
            this._stopDispatching();
          }
        }, t.prototype.isDispatching = function () {
          return this._isDispatching;
        }, t.prototype._invokeCallback = function (t) {
          this._isPending[t] = !0, this._callbacks[t](this._pendingPayload), this._isHandled[t] = !0;
        }, t.prototype._startDispatching = function (t) {
          for (var e in this._callbacks) this._isPending[e] = !1, this._isHandled[e] = !1;
          this._pendingPayload = t, this._isDispatching = !0;
        }, t.prototype._stopDispatching = function () {
          delete this._pendingPayload, this._isDispatching = !1;
        }, t;
      }();
    t.exports = o;
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t, e, n, r, o, i, a, s) {
      if (!t) {
        var u;
        if (void 0 === e) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, r, o, i, a, s],
            f = 0;
          (u = new Error(e.replace(/%s/g, function () {
            return c[f++];
          }))).name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(16);
    function o() {}
    function i() {}
    i.resetWarningCache = o, t.exports = function () {
      function t(t, e, n, o, i, a) {
        if (a !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }
      function e() {
        return t;
      }
      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }, function (t, e) {
    t.exports = Array.isArray || function (t) {
      return "[object Array]" == Object.prototype.toString.call(t);
    };
  }, function (t, e, n) {
    "use strict";

    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var r = "function" == typeof Symbol && Symbol.for,
      o = r ? Symbol.for("react.element") : 60103,
      i = r ? Symbol.for("react.portal") : 60106,
      a = r ? Symbol.for("react.fragment") : 60107,
      s = r ? Symbol.for("react.strict_mode") : 60108,
      u = r ? Symbol.for("react.profiler") : 60114,
      c = r ? Symbol.for("react.provider") : 60109,
      f = r ? Symbol.for("react.context") : 60110,
      l = r ? Symbol.for("react.async_mode") : 60111,
      p = r ? Symbol.for("react.concurrent_mode") : 60111,
      h = r ? Symbol.for("react.forward_ref") : 60112,
      y = r ? Symbol.for("react.suspense") : 60113,
      d = r ? Symbol.for("react.suspense_list") : 60120,
      v = r ? Symbol.for("react.memo") : 60115,
      m = r ? Symbol.for("react.lazy") : 60116,
      g = r ? Symbol.for("react.block") : 60121,
      b = r ? Symbol.for("react.fundamental") : 60117,
      _ = r ? Symbol.for("react.responder") : 60118,
      x = r ? Symbol.for("react.scope") : 60119;
    function w(t) {
      if ("object" == typeof t && null !== t) {
        var e = t.$$typeof;
        switch (e) {
          case o:
            switch (t = t.type) {
              case l:
              case p:
              case a:
              case u:
              case s:
              case y:
                return t;
              default:
                switch (t = t && t.$$typeof) {
                  case f:
                  case h:
                  case m:
                  case v:
                  case c:
                    return t;
                  default:
                    return e;
                }
            }
          case i:
            return e;
        }
      }
    }
    function O(t) {
      return w(t) === p;
    }
    e.AsyncMode = l, e.ConcurrentMode = p, e.ContextConsumer = f, e.ContextProvider = c, e.Element = o, e.ForwardRef = h, e.Fragment = a, e.Lazy = m, e.Memo = v, e.Portal = i, e.Profiler = u, e.StrictMode = s, e.Suspense = y, e.isAsyncMode = function (t) {
      return O(t) || w(t) === l;
    }, e.isConcurrentMode = O, e.isContextConsumer = function (t) {
      return w(t) === f;
    }, e.isContextProvider = function (t) {
      return w(t) === c;
    }, e.isElement = function (t) {
      return "object" == typeof t && null !== t && t.$$typeof === o;
    }, e.isForwardRef = function (t) {
      return w(t) === h;
    }, e.isFragment = function (t) {
      return w(t) === a;
    }, e.isLazy = function (t) {
      return w(t) === m;
    }, e.isMemo = function (t) {
      return w(t) === v;
    }, e.isPortal = function (t) {
      return w(t) === i;
    }, e.isProfiler = function (t) {
      return w(t) === u;
    }, e.isStrictMode = function (t) {
      return w(t) === s;
    }, e.isSuspense = function (t) {
      return w(t) === y;
    }, e.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === a || t === p || t === u || t === s || t === y || t === d || "object" == typeof t && null !== t && (t.$$typeof === m || t.$$typeof === v || t.$$typeof === c || t.$$typeof === f || t.$$typeof === h || t.$$typeof === b || t.$$typeof === _ || t.$$typeof === x || t.$$typeof === g);
    }, e.typeOf = w;
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "defaultSession", function () {
      return at;
    }), n.d(e, "Session", function () {
      return ct;
    }), n.d(e, "PrivateRoute", function () {
      return ft;
    });
    var r = n(0),
      o = n.n(r),
      i = n(6),
      a = n.n(i);
    function s(t, e) {
      t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
    }
    var u = n(1),
      c = n.n(u);
    function f() {
      return (f = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    function l(t) {
      return "/" === t.charAt(0);
    }
    function p(t, e) {
      for (var n = e, r = n + 1, o = t.length; r < o; n += 1, r += 1) t[n] = t[r];
      t.pop();
    }
    var h = function (t, e) {
      void 0 === e && (e = "");
      var n,
        r = t && t.split("/") || [],
        o = e && e.split("/") || [],
        i = t && l(t),
        a = e && l(e),
        s = i || a;
      if (t && l(t) ? o = r : r.length && (o.pop(), o = o.concat(r)), !o.length) return "/";
      if (o.length) {
        var u = o[o.length - 1];
        n = "." === u || ".." === u || "" === u;
      } else n = !1;
      for (var c = 0, f = o.length; f >= 0; f--) {
        var h = o[f];
        "." === h ? p(o, f) : ".." === h ? (p(o, f), c++) : c && (p(o, f), c--);
      }
      if (!s) for (; c--; c) o.unshift("..");
      !s || "" === o[0] || o[0] && l(o[0]) || o.unshift("");
      var y = o.join("/");
      return n && "/" !== y.substr(-1) && (y += "/"), y;
    };
    function y(t) {
      return t.valueOf ? t.valueOf() : Object.prototype.valueOf.call(t);
    }
    var d = function t(e, n) {
      if (e === n) return !0;
      if (null == e || null == n) return !1;
      if (Array.isArray(e)) return Array.isArray(n) && e.length === n.length && e.every(function (e, r) {
        return t(e, n[r]);
      });
      if ("object" == typeof e || "object" == typeof n) {
        var r = y(e),
          o = y(n);
        return r !== e || o !== n ? t(r, o) : Object.keys(Object.assign({}, e, n)).every(function (r) {
          return t(e[r], n[r]);
        });
      }
      return !1;
    };
    var v = function (t, e) {
      if (!t) throw new Error("Invariant failed");
    };
    function m(t) {
      var e = t.pathname,
        n = t.search,
        r = t.hash,
        o = e || "/";
      return n && "?" !== n && ("?" === n.charAt(0) ? n : "?" + n), r && "#" !== r && ("#" === r.charAt(0) ? r : "#" + r), o;
    }
    function g(t, e, n, r) {
      var o;
      "string" == typeof t ? (o = function (t) {
        var e = t || "/",
          n = "",
          r = "",
          o = e.indexOf("#");
        -1 !== o && (r = e.substr(o), e = e.substr(0, o));
        var i = e.indexOf("?");
        return -1 !== i && (n = e.substr(i), e = e.substr(0, i)), {
          pathname: e,
          search: "?" === n ? "" : n,
          hash: "#" === r ? "" : r
        };
      }(t)).state = e : (void 0 === (o = f({}, t)).pathname && (o.pathname = ""), o.search ? "?" !== o.search.charAt(0) && (o.search = "?" + o.search) : o.search = "", o.hash ? "#" !== o.hash.charAt(0) && (o.hash = "#" + o.hash) : o.hash = "", void 0 !== e && void 0 === o.state && (o.state = e));
      try {
        o.pathname = decodeURI(o.pathname);
      } catch (t) {
        throw t instanceof URIError ? new URIError('Pathname "' + o.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.') : t;
      }
      return n && (o.key = n), r ? o.pathname ? "/" !== o.pathname.charAt(0) && (o.pathname = h(o.pathname, r.pathname)) : o.pathname = r.pathname : o.pathname || (o.pathname = "/"), o;
    }
    function b() {
      var t = null;
      var e = [];
      return {
        setPrompt: function (e) {
          return e, function () {
            t === e && null;
          };
        },
        confirmTransitionTo: function (e, n, r, o) {
          if (null != t) {
            var i = "function" == typeof t ? t(e, n) : t;
            "string" == typeof i ? "function" == typeof r ? r(i, o) : o(!0) : o(!1 !== i);
          } else o(!0);
        },
        appendListener: function (t) {
          var n = !0;
          function r() {
            n && t.apply(void 0, arguments);
          }
          return e.push(r), function () {
            !1, e.filter(function (t) {
              return t !== r;
            });
          };
        },
        notifyListeners: function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
          e.forEach(function (t) {
            return t.apply(void 0, n);
          });
        }
      };
    }
    "undefined" == typeof window || !window.document || window.document.createElement;
    function _(t, e, n) {
      return Math.min(Math.max(t, e), n);
    }
    function x(t) {
      void 0 === t && {};
      var e = t,
        n = e.getUserConfirmation,
        r = e.initialEntries,
        o = void 0 === r ? ["/"] : r,
        i = e.initialIndex,
        a = void 0 === i ? 0 : i,
        s = e.keyLength,
        u = void 0 === s ? 6 : s,
        c = b();
      function l(t) {
        f(x, t), x.length = x.entries.length, c.notifyListeners(x.location, x.action);
      }
      function p() {
        return Math.random().toString(36).substr(2, u);
      }
      var h = _(a, 0, o.length - 1),
        y = o.map(function (t) {
          return g(t, void 0, "string" == typeof t ? p() : t.key || p());
        }),
        d = m;
      function v(t) {
        var e = _(x.index + t, 0, x.entries.length - 1),
          r = x.entries[e];
        c.confirmTransitionTo(r, "POP", n, function (t) {
          t ? l({
            action: "POP",
            location: r,
            index: e
          }) : l();
        });
      }
      var x = {
        length: y.length,
        action: "POP",
        location: y[h],
        index: h,
        entries: y,
        createHref: d,
        push: function (t, e) {
          var r = g(t, e, p(), x.location);
          c.confirmTransitionTo(r, "PUSH", n, function (t) {
            if (t) {
              var e = x.index + 1,
                n = x.entries.slice(0);
              n.length > e ? n.splice(e, n.length - e, r) : n.push(r), l({
                action: "PUSH",
                location: r,
                index: e,
                entries: n
              });
            }
          });
        },
        replace: function (t, e) {
          var r = g(t, e, p(), x.location);
          c.confirmTransitionTo(r, "REPLACE", n, function (t) {
            t && (x.entries[x.index] = r, l({
              action: "REPLACE",
              location: r
            }));
          });
        },
        go: v,
        goBack: function () {
          v(-1);
        },
        goForward: function () {
          v(1);
        },
        canGo: function (t) {
          var e = x.index + t;
          return e >= 0 && e < x.entries.length;
        },
        block: function (t) {
          return void 0 === t && !1, c.setPrompt(t);
        },
        listen: function (t) {
          return c.appendListener(t);
        }
      };
      return x;
    }
    var w = n(2),
      O = n.n(w),
      S = n(8),
      P = n.n(S);
    function j(t) {
      var e = [];
      return {
        on: function (t) {
          e.push(t);
        },
        off: function (t) {
          e = e.filter(function (e) {
            return e !== t;
          });
        },
        get: function () {
          return t;
        },
        set: function (n, r) {
          t = n, e.forEach(function (e) {
            return e(t, r);
          });
        }
      };
    }
    var E = o.a.createContext || function (t, e) {
        var n,
          o,
          i = "__create-react-context-" + P()() + "__",
          a = function (t) {
            function n() {
              var e;
              return (e = t.apply(this, arguments) || this).emitter = j(e.props.value), e;
            }
            O()(n, t);
            var r = n.prototype;
            return r.getChildContext = function () {
              var t;
              return (t = {})[i] = this.emitter, t;
            }, r.componentWillReceiveProps = function (t) {
              if (this.props.value !== t.value) {
                var n,
                  r = this.props.value,
                  o = t.value;
                ((i = r) === (a = o) ? 0 !== i || 1 / i == 1 / a : i != i && a != a) ? n = 0 : (n = "function" == typeof e ? e(r, o) : 1073741823, 0 !== (n |= 0) && this.emitter.set(t.value, n));
              }
              var i, a;
            }, r.render = function () {
              return this.props.children;
            }, n;
          }(r.Component);
        a.childContextTypes = ((n = {})[i] = c.a.object.isRequired, n);
        var s = function (e) {
          function n() {
            var t;
            return (t = e.apply(this, arguments) || this).state = {
              value: t.getValue()
            }, t.onUpdate = function (e, n) {
              0 != ((0 | t.observedBits) & n) && t.setState({
                value: t.getValue()
              });
            }, t;
          }
          O()(n, e);
          var r = n.prototype;
          return r.componentWillReceiveProps = function (t) {
            var e = t.observedBits;
            this.observedBits = null == e ? 1073741823 : e;
          }, r.componentDidMount = function () {
            this.context[i] && this.context[i].on(this.onUpdate);
            var t = this.props.observedBits;
            this.observedBits = null == t ? 1073741823 : t;
          }, r.componentWillUnmount = function () {
            this.context[i] && this.context[i].off(this.onUpdate);
          }, r.getValue = function () {
            return this.context[i] ? this.context[i].get() : t;
          }, r.render = function () {
            return (t = this.props.children, Array.isArray(t) ? t[0] : t)(this.state.value);
            var t;
          }, n;
        }(r.Component);
        return s.contextTypes = ((o = {})[i] = c.a.object, o), {
          Provider: a,
          Consumer: s
        };
      },
      C = n(3),
      k = n.n(C);
    n(5);
    function L(t, e) {
      if (null == t) return {};
      var n,
        r,
        o = {},
        i = Object.keys(t);
      for (0; r < i.length; r++) i[r], e.indexOf(n) >= 0 || (o[n] = t[n]);
      return o;
    }
    n(9);
    var R = function (t) {
        var e = E();
        return e.displayName = t, e;
      }("Router"),
      $ = function (t) {
        function e(e) {
          var n;
          return (n = t.call(this, e) || this).state = {
            location: e.history.location
          }, n._isMounted = !1, n._pendingLocation = null, e.staticContext || (n.unlisten = e.history.listen(function (t) {
            n._isMounted ? n.setState({
              location: t
            }) : n._pendingLocation = t;
          })), n;
        }
        s(e, t), e.computeRootMatch = function (t) {
          return {
            path: "/",
            url: "/",
            params: {},
            isExact: "/" === t
          };
        };
        var n = e.prototype;
        return n.componentDidMount = function () {
          this._isMounted = !0, this._pendingLocation && this.setState({
            location: this._pendingLocation
          });
        }, n.componentWillUnmount = function () {
          this.unlisten && this.unlisten();
        }, n.render = function () {
          return o.a.createElement(R.Provider, {
            children: this.props.children || null,
            value: {
              history: this.props.history,
              location: this.state.location,
              match: e.computeRootMatch(this.state.location.pathname),
              staticContext: this.props.staticContext
            }
          });
        }, e;
      }(o.a.Component);
    o.a.Component;
    var T = function (t) {
      function e() {
        return t.apply(this, arguments) || this;
      }
      s(e, t);
      var n = e.prototype;
      return n.componentDidMount = function () {
        this.props.onMount && this.props.onMount.call(this, this);
      }, n.componentDidUpdate = function (t) {
        this.props.onUpdate && this.props.onUpdate.call(this, this, t);
      }, n.componentWillUnmount = function () {
        this.props.onUnmount && this.props.onUnmount.call(this, this);
      }, n.render = function () {
        return null;
      }, e;
    }(o.a.Component);
    var A = {},
      M = 0;
    function U(t, e) {
      return void 0 === t && (t = "/"), void 0 === e && (e = {}), "/" === t ? t : function (t) {
        if (A[t]) return A[t];
        var e = k.a.compile(t);
        return M < 1e4 && (A[t] = e, M++), e;
      }(t)(e, {
        pretty: !0
      });
    }
    function D(t) {
      var e = t.computedMatch,
        n = t.to,
        r = t.push,
        i = void 0 !== r && r;
      return o.a.createElement(R.Consumer, null, function (t) {
        t || v(!1);
        var r = t.history,
          a = t.staticContext,
          s = i ? r.push : r.replace,
          u = g(e ? "string" == typeof n ? U(n, e.params) : f({}, n, {
            pathname: U(n.pathname, e.params)
          }) : n);
        return a ? (s(u), null) : o.a.createElement(T, {
          onMount: function () {
            s(u);
          },
          onUpdate: function (t, e) {
            var n,
              r,
              o = g(e.to);
            n = o, r = f({}, u, {
              key: o.key
            }), n.pathname === r.pathname && n.search === r.search && n.hash === r.hash && n.key === r.key && d(n.state, r.state) || s(u);
          },
          to: n
        });
      });
    }
    var I = {},
      N = 0;
    function F(t, e) {
      void 0 === e && (e = {}), ("string" == typeof e || Array.isArray(e)) && (e = {
        path: e
      });
      var n = e,
        r = n.path,
        o = n.exact,
        i = void 0 !== o && o,
        a = n.strict,
        s = void 0 !== a && a,
        u = n.sensitive,
        c = void 0 !== u && u;
      return [].concat(r).reduce(function (e, n) {
        if (!n && "" !== n) return null;
        if (e) return e;
        var r = function (t, e) {
            var n = "" + e.end + e.strict + e.sensitive,
              r = I[n] || (I[n] = {});
            if (r[t]) return r[t];
            var o = [],
              i = {
                regexp: k()(t, o, e),
                keys: o
              };
            return N < 1e4 && (r[t] = i, N++), i;
          }(n, {
            end: i,
            strict: s,
            sensitive: c
          }),
          o = r.regexp,
          a = r.keys,
          u = o.exec(t);
        if (!u) return null;
        var f = u[0],
          l = u.slice(1),
          p = t === f;
        return i && !p ? null : {
          path: n,
          url: "/" === n && "" === f ? "/" : f,
          isExact: p,
          params: a.reduce(function (t, e, n) {
            return t[e.name] = l[n], t;
          }, {})
        };
      }, null);
    }
    var V = function (t) {
      function e() {
        return t.apply(this, arguments) || this;
      }
      return s(e, t), e.prototype.render = function () {
        var t = this;
        return o.a.createElement(R.Consumer, null, function (e) {
          e || v(!1);
          var n = t.props.location || e.location,
            r = f({}, e, {
              location: n,
              match: t.props.computedMatch ? t.props.computedMatch : t.props.path ? F(n.pathname, t.props) : e.match
            }),
            i = t.props,
            a = i.children,
            s = i.component,
            u = i.render;
          return Array.isArray(a) && 0 === a.length && (a = null), o.a.createElement(R.Provider, {
            value: r
          }, r.match ? a ? "function" == typeof a ? a(r) : a : s ? o.a.createElement(s, r) : u ? u(r) : null : "function" == typeof a ? a(r) : null);
        });
      }, e;
    }(o.a.Component);
    function q(t) {
      return "/" === t.charAt(0) ? t : "/" + t;
    }
    function B(t, e) {
      if (!t) return e;
      var n = q(t);
      return 0 !== e.pathname.indexOf(n) ? e : f({}, e, {
        pathname: e.pathname.substr(n.length)
      });
    }
    function H(t) {
      return "string" == typeof t ? t : m(t);
    }
    function W(t) {
      return function () {
        v(!1);
      };
    }
    function z() {}
    o.a.Component;
    o.a.Component;
    o.a.useContext;
    function J() {
      return (J = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    function Y(t) {
      return (Y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function K(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }
    function G(t, e) {
      return (G = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function Q(t, e) {
      return !e || "object" !== Y(e) && "function" != typeof e ? X(t) : e;
    }
    function X(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function Z() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }
    function tt(t) {
      return (tt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function et(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function nt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2 ? et(Object(n), !0).forEach(function (e) {
          rt(t, e, n[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : et(Object(n)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
        });
      }
      return t;
    }
    function rt(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }
    var ot = new (n(7).Dispatcher)(),
      it = function () {
        return new Date().getTime();
      },
      at = function (t) {
        return nt({
          active: !1,
          name: null,
          payload: {},
          timeLeft: null,
          getTimeLeft: function () {
            return 0;
          },
          expiration: 864e5,
          createdAt: null,
          expired: !1
        }, t);
      },
      st = new (function (t) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && G(t, e);
        }(a, t);
        var e,
          n,
          r,
          o,
          i = (e = a, function () {
            var t,
              n = tt(e);
            if (Z()) {
              var r = tt(this).constructor;
              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);
            return Q(this, t);
          });
        function a() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (t = i.call(this)).sessionName = null, ot.register(t.setPersistedState.bind(X(t))), t;
        }
        return n = a, (r = [{
          key: "setPersistedState",
          value: function (t) {
            "string" == typeof t.name && (this.sessionName = t.name);
            var e = this.getSession(),
              n = Object.assign(e || {}, t);
            return localStorage.setItem(this.sessionName, JSON.stringify(n)), this.emit("session-change", n), n;
          }
        }, {
          key: "getPersistedState",
          value: function () {
            this.sessionName || console.error("React Session: Error! You need to specity a session name");
            var t = JSON.parse(localStorage.getItem(this.sessionName));
            return t ? (t.getTimeLeft = function () {
              return 0;
            }, t.active && (t.getTimeLeft = function () {
              return t.expiration - (it() - t.createdAt);
            }, t.timeLeft = t.getTimeLeft(), t.expired = t.timeLeft < 0), t.isValid = !t.expired && t.active, t) : at({
              name: this.sessionName
            });
          }
        }, {
          key: "getSession",
          value: function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
            return t && (this.sessionName = t), this.getPersistedState();
          }
        }]) && K(n.prototype, r), o && K(n, o), a;
      }(a.a))(),
      ut = {
        start: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          ot.dispatch(nt({}, at, {}, e, {
            name: t,
            active: !0,
            createdAt: it()
          }));
        },
        onExpiration: function (t) {
          var e = st.getSession();
          if (!e.active) throw new Error("You have to start a the session before listening to its expiration");
          e.expired ? t(e) : setTimeout(function () {
            return t(st.getSession());
          }, e.timeLeft), e.timeLeft;
        },
        setPayload: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = st.getSession(),
            n = Object.assign(e.payload, t);
          ot.dispatch({
            payload: n
          });
        },
        getPayload: function () {
          var t = st.getSession();
          return t ? t.payload : null;
        },
        setUser: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          console.warn("React-Session: The setUser function is deprecated, use setPayload instead.");
          var e = st.getSession(),
            n = Object.assign(e.user, t);
          ot.dispatch({
            user: n
          });
        },
        destroy: function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
            e = st.getSession(t);
          "Session ".concat(e.name, " destroyed..."), ot.dispatch(at({
            name: e.name
          }));
        }
      },
      ct = {
        store: st,
        get: function () {
          return st.getSession.apply(st, arguments);
        },
        onChange: function (t) {
          return st.on("session-change", t), function () {
            return st.removeListener("session-change", t);
          };
        },
        actions: ut,
        onExpiration: ut.onExpiration,
        setPayload: ut.setPayload,
        getPayload: ut.getPayload,
        start: ut.start,
        destroy: ut.destroy,
        getSession: function () {
          return st.getSession.apply(st, arguments);
        },
        login: ut.start,
        logout: ut.destroy,
        setUser: ut.setUser
      },
      ft = function (t) {
        var e = t.component,
          n = Object.assign({}, t);
        delete n.component;
        var r = st.getSession();
        return o.a.createElement(V, J({}, n, {
          render: function (t) {
            return r.active ? o.a.createElement(e, J({}, n, t)) : o.a.createElement(D, {
              to: {
                pathname: "/login",
                state: {
                  from: t.location
                }
              }
            });
          }
        }));
      };
  }]);
});